import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 510-light-beacon
 * @see {GlyphIcon}
 */
const LightBeaconIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M25,25v3H7V25a1,1,0,0,1,1-1H24A1,1,0,0,1,25,25ZM16,8.5a.99943.99943,0,0,0,1-1V5a1,1,0,0,0-2,0V7.5A.99943.99943,0,0,0,16,8.5Zm6.1084,1.3916a.99672.99672,0,0,0,.707-.293L24.58887,7.8252A.9999.9999,0,1,0,23.1748,6.41113L21.40137,8.18457a1,1,0,0,0,.707,1.707Zm-12.92383-.293a.99989.99989,0,0,0,1.41406-1.41406L8.8252,6.41113A.9999.9999,0,0,0,7.41113,7.8252ZM26.90234,14H24.36816a1,1,0,0,0,0,2h2.53418a1,1,0,0,0,0-2ZM8.63184,15a.99943.99943,0,0,0-1-1H5.09766a1,1,0,0,0,0,2H7.63184A.99943.99943,0,0,0,8.63184,15Zm1.95037-2.49323A3,3,0,0,1,13.54138,10h4.91724a3,3,0,0,1,2.95917,2.50677L23,22H9Zm1.3299,4.18659a1.00059,1.00059,0,0,0,.82129,1.15137.96846.96846,0,0,0,.166.01367,1.00056,1.00056,0,0,0,.98536-.835l.43359-2.59766a1,1,0,0,0-1.97266-.33008Z";
	}
}

export default LightBeaconIcon;